import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import abomedlogo from "../asset/images/abomed-logo-mP42DzyBX4t2OKyb.avif";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('partner_token');
    setIsLoggedIn(!!token);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  const handleLogout = () => {
    localStorage.removeItem('partner_token');
    setIsLoggedIn(false);
    navigate('/partner/login');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        closeMenu();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="logo">
          <img src={abomedlogo} alt="Abomed-Healthcare Solutions" />
        </div>

        <div className="hamburger" ref={hamburgerRef} onClick={toggleMenu}>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <ul
          ref={menuRef}
          className={`nav-links ${isMenuOpen ? 'active' : ''}`}
        >
          <li><Link to="/" onClick={closeMenu}>Home</Link></li>
          <li><Link to="/about" onClick={closeMenu}>About Us</Link></li>
          <li><Link to="/services" onClick={closeMenu}>Services</Link></li>
          <li><Link to="/contact" onClick={closeMenu}>Contact Us</Link></li>

          <li className={`dropdown ${dropdownOpen ? 'open' : ''}`}>
            <span className="dropdown-title" onClick={toggleDropdown}>
              Marketing Partner ▾
            </span>
            {dropdownOpen && (
              <ul className="dropdown-menu">
                {!isLoggedIn ? (
                  <>
                    <li><Link to="/partner/register" onClick={closeMenu}>Register Now</Link></li>
                    <li><Link to="/partner/login" onClick={closeMenu}>Login</Link></li>
                    <li><Link to="/partner/faq" onClick={closeMenu}>FAQ</Link></li>
                  </>
                ) : (
                  <>
                    <li><Link to="/partner">Panel</Link></li>
                    <li><Link to="/partner/faq" onClick={closeMenu}>FAQ</Link></li>
                    <li><span onClick={handleLogout} style={{cursor:'pointer'}}>Logout</span></li>
                  </>
                )}
              </ul>
            )}
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
